var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMethods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_90)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72599 25.0807C8.61855 24.4463 41.7649 24.4765 44.0377 25.2015C45.2478 26.2287 44.5985 38.8565 44.3328 40.1556L5.66696 40.3066C4.95858 38.1919 5.19471 38.917 5.10616 36.6512L5.16519 27.2558C5.19471 27.0142 5.22422 26.8933 5.25374 26.6818L5.72599 25.0807ZM25.5017 9.67352C33.1168 9.67352 48.406 7.37754 44.5099 14.054C43.5949 15.6551 40.053 14.9603 38.0459 14.9603H11.2455C8.26436 14.9301 5.66696 15.8968 5.10616 13.1779C4.27971 9.15994 6.55244 9.58289 9.50403 9.64331C14.8464 9.70373 20.1888 9.67352 25.5017 9.67352ZM3.74842 4.83989C-1.32832 6.83376 0.206512 15.7458 0.236028 24.3557C0.265544 32.3009 -1.15122 42.3005 2.89246 44.5663C4.72245 45.5934 43.2703 45.9861 46.3104 45.0496C51.4462 43.4485 49.6457 31.7572 49.6457 25.5339C49.6457 19.5825 51.3871 7.52859 47.0483 5.23262C45.5725 4.44716 5.72599 4.05442 3.74842 4.83989Z",
    fill: "#8B0E01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethods);
export default __webpack_public_path__ + "static/media/PaymentMethods.118bb77657217d4b07fa06c6536784fa.svg";
export { ForwardRef as ReactComponent };